import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { s3baseUrl } from "src/config/config";
import {
  decode_markdown,
  get_short_string,
  getTimeBasedOnDate,
} from "src/utils/constants";
import { htmlDecode } from "src/utils/convertHtmlForChat";
import icons from "src/design-system/icons";
import GrIcon from "src/design-system/components/GrIcon";
import GrChatListRow from "src/design-system/components/GrChatListRow";

// Today's date key, computed once per list render by the caller (not per row).
export const todayKey = () =>
  getTimeBasedOnDate(new Date().toISOString(), "YYYY-MM-DD");

// List time: today's messages show the time, older ones the date (same on the chat page and the popover).
export const chatShortTime = (date, today) =>
  getTimeBasedOnDate(date, "YYYY-MM-DD") === today
    ? getTimeBasedOnDate(date, "hh:mm A")
    : getTimeBasedOnDate(date, "DD MMM YYYY");

const TYPE_ICONS = {
  image: icons.camera,
  video: icons.video,
  audio: icons.mic,
};
const TYPE_TEXT = {
  image: "Photo",
  video: "Video",
  html: "a new message received",
  audio: "Voice Message",
};

// One conversation row (chat page list and header popover): same avatar, name, preview, time and unread.
export default function ChatListItem({ chat, today, selected, onClick }) {
  const type = chat?.message_type;
  return (
    <GrChatListRow
      onClick={onClick}
      selected={selected}
      src={s3baseUrl + chat?.receiver_profile?.profileImage}
      name={chat?.receiver_profile?.name}
      online={!!chat?.receiver_profile?.isOnline}
      unread={chat?.my_profile?.unread_message_count}
      tag={
        TYPE_ICONS[type] ? <GrIcon icon={TYPE_ICONS[type]} size="sm" /> : null
      }
      preview={
        TYPE_TEXT[type] ||
        (chat?.lastMessage &&
          get_short_string(htmlDecode(decode_markdown(chat?.lastMessage)), 60))
      }
      time={
        chat?.lastMessageDateTime && (
          <Tooltip
            title={getTimeBasedOnDate(
              chat?.lastMessageDateTime,
              "DD MMM YYYY [at] hh:mm A"
            )}
          >
            <span>{chatShortTime(chat?.lastMessageDateTime, today)}</span>
          </Tooltip>
        )
      }
    />
  );
}
